export default "__VITE_ASSET__BdCwHwri__"